import React from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import { current } from '@reduxjs/toolkit'

interface WalkingPhotosProps {
  walkingPoints: any
  assetUrl?: string
}

const WalkingPhotos = ({ walkingPoints, assetUrl }: WalkingPhotosProps) => {
  const { locId } = useSelector((state: any) => state.location)
  const { stopPoints, nextStop, currentStop } = walkingPoints

  return (
    <>
      {stopPoints?.map((photo: any, index) => (
        <div
          tabIndex={0}
          aria-label={`Currently on point ${index + 1} coming from ${
            currentStop.title
          } going to ${nextStop.title}`}
        >
          <Box
            component={'div'}
            sx={{
              width: '100%',
              height: 'auto',
              background: '#f2f3f4',
              textAlign: 'center',
            }}
          >
            <Box
              sx={{ width: '100%', height: 'auto' }}
              component={'img'}
              src={`${assetUrl}/media/${locId}/tour/${photo.media_id}/1536_front.jpg`}
            />
          </Box>
          <p>{`Currently on point ${index + 1} of ${
            stopPoints.length
          } coming from ${currentStop.title} going to ${nextStop.title}`}</p>
        </div>
      ))}
    </>
  )
}

export default WalkingPhotos
